"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DollarSignCircleSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var DollarSignCircleSVG = function DollarSignCircleSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M16 2a14 14 0 1014 14A14 14 0 0016 2zm.74 20.13v.38a1 1 0 01-2 0v-.43a3.92 3.92 0 01-3.35-2.27 1.38 1.38 0 01-.1-.49c0-.53.36-.85 1-.85a1 1 0 011 .65 3.45 3.45 0 003.26 1.49c1.39-.08 2.22-.74 2.22-1.76s-.6-1.44-2.21-1.83l-1.61-.36c-2.42-.54-3.55-1.59-3.55-3.32s1.31-3.05 3.39-3.4V9.5a1 1 0 012 0v.39c1.84.21 3.21 1.1 3.62 2.39a1.52 1.52 0 01.08.49c0 .45-.35.74-.91.74a1.09 1.09 0 01-1-.64 3.2 3.2 0 00-3-1.47c-1.25.13-2.11.78-2.11 1.7s.64 1.43 2 1.79l1.65.36c2.57.58 3.67 1.57 3.67 3.32-.04 2.34-2.06 3.36-4.05 3.56z"
  }));
};
exports.DollarSignCircleSVG = DollarSignCircleSVG;
DollarSignCircleSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(DollarSignCircleSVG);
exports.default = _default;